import { Graphics } from 'pixi.js';
import { type System, ComponentStore } from '@ecs/world';
import type { CameraResource, KinematicComponent, TransformComponent } from '@game/scenes/characterPrototype/types';

export type DebugColliderStyle = {
	fillColor: number;
	fillAlpha: number;
	strokeColor: number;
	strokeAlpha: number;
	strokeWidth: number;
};

export function createDebugColliderSyncSystem(
	debugColliderGraphics: ComponentStore<Graphics>,
	transforms: ComponentStore<TransformComponent>,
	kinematics: ComponentStore<KinematicComponent>,
	style: DebugColliderStyle
): System {
	return ({ world }) => {
		const camera = world.getResource<CameraResource>('camera');
		const offsetY = camera ? camera.y : 0;

		debugColliderGraphics.forEach((graphic, entity) => {
			const transform = transforms.get(entity);
			if (!transform) return;
			const kinematic = kinematics.get(entity);
			if (!kinematic) return;

			const halfW = kinematic.halfSize;
			const halfH = kinematic.halfHeight ?? kinematic.halfSize;
			const w = halfW * 2;
			const h = halfH * 2;
			const radius = Math.min(8, Math.max(0, Math.min(w, h) * 0.25));

			graphic.position.set(transform.x, transform.y - offsetY);
			graphic.clear();
			graphic.roundRect(-w / 2, -h / 2, w, h, radius);
			graphic.fill({ color: style.fillColor, alpha: style.fillAlpha });
			graphic.stroke({
				color: style.strokeColor,
				alpha: style.strokeAlpha,
				width: style.strokeWidth
			});
		});
	};
}


